import { defaultMasteryLabels, isScreenshotMode } from "@constants/common";
import { useAppStore } from "@hooks/useAppStore";
import type { ScoreRange } from "@memorang/ui/types";
import type { AppTheme } from "@memorang/ui/useAppTheme";

const getMasteryLabels = () => {
	const masteryLabels = useAppStore.getState().app?.masteryLabels;
	return masteryLabels || defaultMasteryLabels;
};

export const getProgressColorScale = (
	score: number,
	theme: AppTheme,
	scoreRanges: ScoreRange[],
) => {
	const { high, low, none: empty, medium } = theme.palette.progress;
	const lowScoreRange = scoreRanges[0].rangeArray[1];
	const mediumScoreRange = scoreRanges[1].rangeArray[1];

	if (isScreenshotMode) {
		return [high, empty];
	}
	if (score <= lowScoreRange) {
		return [low, empty];
	}
	if (score <= mediumScoreRange) {
		return [medium, empty];
	}
	return [high, empty];
};
export { getMasteryLabels };
